import React, { useState, useEffect } from 'react';
import { register } from './glitchScheduler';

const css = `
.gi-wrap {
  position: relative;
  display: inline-block;
  line-height: 0;
}

.gi-main {
  display: block;
  position: relative;
  z-index: 1;
}

.gi-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  pointer-events: none;
  opacity: 0.35;
}

.gi-scan {
  position: absolute;
  inset: 0;
  z-index: 3;
  pointer-events: none;
  background: repeating-linear-gradient(
    0deg,
    transparent,
    transparent 1px,
    rgba(0,0,0,0.08) 1px,
    rgba(0,0,0,0.08) 2px
  );
  animation: giScanDrift 0.5s linear infinite;
}

@keyframes giScanDrift {
  from { background-position: 0 0; }
  to { background-position: 0 2px; }
}

@keyframes giGlitchMain {
  0%   { transform: translate(0); }
  20%  { transform: translate(2px, 0); }
  40%  { transform: translate(-2px, 0); }
  60%  { transform: translate(1px, 0); }
  80%  { transform: translate(-1px, 0); }
  100% { transform: translate(0); }
}

@keyframes giGlitchTop {
  0%   { transform: translate(0); }
  20%  { transform: translate(-3px, 0); }
  40%  { transform: translate(3px, 0); }
  60%  { transform: translate(-1px, 0); }
  80%  { transform: translate(2px, 0); }
  100% { transform: translate(0); }
}

@keyframes giGlitchBot {
  0%   { transform: translate(0); }
  20%  { transform: translate(3px, 0); }
  40%  { transform: translate(-3px, 0); }
  60%  { transform: translate(1px, 0); }
  80%  { transform: translate(-2px, 0); }
  100% { transform: translate(0); }
}
`;

let styleInjected = false;

const GlitchImage = ({ src, alt, width, height, className, intensity = 1 }) => {
  const [glitching, setGlitching] = useState(false);

  useEffect(() => {
    const unregister = register(() => {
      setGlitching(true);
      setTimeout(() => setGlitching(false), 350);
    });
    return unregister;
  }, []);

  if (!styleInjected && typeof document !== 'undefined') {
    const tag = document.createElement('style');
    tag.textContent = css;
    document.head.appendChild(tag);
    styleInjected = true;
  }

  const anim = glitching ? 'giGlitchMain 0.35s ease-out' : 'none';
  const animTop = glitching ? 'giGlitchTop 0.35s ease-out' : 'none';
  const animBot = glitching ? 'giGlitchBot 0.35s ease-out' : 'none';
  const imgStyle = { width, height, objectFit: 'contain' };

  return (
    <span className={`gi-wrap ${className || ''}`}>
      <img
        src={src}
        alt={alt}
        className="gi-main"
        style={{
          ...imgStyle,
          animation: anim,
          filter: `drop-shadow(0 0 ${3 * intensity}px rgba(255,215,0,0.4))`,
        }}
      />
      <img
        src={src}
        alt=""
        className="gi-layer"
        style={{
          ...imgStyle,
          filter: 'brightness(2) sepia(1) saturate(20) hue-rotate(-15deg)',
          opacity: glitching ? 0.6 : 0.4,
          clipPath: 'inset(0 0 50% 0)',
          animation: animTop,
          transition: 'opacity 0.15s',
        }}
      />
      <img
        src={src}
        alt=""
        className="gi-layer"
        style={{
          ...imgStyle,
          filter: 'brightness(1.5) sepia(1) saturate(30) hue-rotate(190deg)',
          opacity: glitching ? 0.65 : 0.45,
          clipPath: 'inset(50% 0 0 0)',
          animation: animBot,
          transition: 'opacity 0.15s',
        }}
      />
      <img
        src={src}
        alt=""
        className="gi-layer"
        style={{
          ...imgStyle,
          filter: 'brightness(3) sepia(1) saturate(15) hue-rotate(10deg)',
          opacity: 0.6,
          clipPath: 'inset(47% 0 47% 0)',
        }}
      />
      <span className="gi-scan" />
    </span>
  );
};

export default GlitchImage;
